<template>
    <div>
        <h2 class="text-center">
            {{ __('Kérjük válaszd ki a termékeket!') }}
        </h2>

        <h4 class="text-center">
            {{ __('Kiválasztott rendelés') }}: #{{ order.id }}
        </h4>

        <table>
            <tbody>
                <tr
                    v-for="product in order.items"
                >
                    <td>
                        <div class="product-return-product-container mb-5">
                            <div class="product-image">
                                <img :src="product.image" :alt="product.name" width="70">
                            </div>

                            <div class="product-data ml-5">
                                <h4>{{ product.name }}</h4>
                                <span>{{ __('Méret') }}: {{ product.size }} </span>
                                <span>{{ __('Szín') }}: {{ product.color }}</span>
                                <span>{{ __('Cikkszám') }}: {{ product.basicCode }}</span>
                            </div>
                        </div>
                    </td>

                    <td class="text-right">
                        <p v-if="product.disabled">
                            {{ __('VISSZAKÜLDVE!') }}
                        </p>

                        <button v-else-if="alreadySelected(product)"
                                style="background: #b7d630;"
                                @click="removeItem(product)"
                        >
                            <i class="fa fa-check"></i>
                            {{ __('Kiválasztva') }}
                        </button>

                        <button v-else @click="addItem(product)">
                            {{ __('Kiválasztom') }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="my-5 text-center">
            <button class="mx-5" @click="goBack">
                {{ __('Vissza') }}
            </button>

            <button
                v-if="selectedItems.length > 0"
                class="mx-5"
                @click="selectItems"
            >
                {{ __('Tovább') }}
            </button>
        </div>
    </div>
</template>


<script>
export default {
    name: 'ProductReturnProductList',

    props: {
        selectedOrder: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            order: this.selectedOrder,
            selectedItems: [],
        }
    },

    watch: {
        selectedOrder() {
            this.order = this.selectedOrder
        }
    },

    methods: {
        addItem(product) {
            this.selectedItems.push(product);
        },

        removeItem(product) {
            this.selectedItems = this.selectedItems.filter(object => {
                return object.key !== product.key;
            });
        },

        alreadySelected(product) {
            return this.selectedItems.some(e => e.key === product.key);
        },

        selectItems() {
            this.$emit('select-items', this.selectedItems);
        },

        goBack() {
            this.$emit('go-back');
        }
    },
}
</script>

<style lang="scss" scoped>
div.product-return-product-container {
    display: flex;

    div.product-image {
        background: #fff;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.43);
    }

    div.product-data {
        display: flex;
        flex-direction: column;

        h4 {
            margin: 0;
        }
    }
}
</style>
